var Side_Ad = _.template(require("./template_side_ad.html"))
var Fix_Ad = _.template(require("./fix_ad.html"))
var Allsee_Ad = _.template(require("./allsee_feed_ad.html"))
import { AdRenderer } from './feeds-ads.js'
var getTemplate = function(opts){
    const spmCCode = opts.spmCCode
    const feedAdInstance = new AdRenderer(opts)
    
    const feedAdTemplateFunc = feedAdInstance.render
    // xps广告c码和xps dom结构模板的映射关系
    var templateFuncMap = {
        'ad-sq1': Side_Ad,
        'ad-sq2': Side_Ad,
        'ad-sq3': Side_Ad,
        'ad-sq4': Side_Ad,
        'ad-sq6': Fix_Ad,
        "fd-link": Allsee_Ad, // 匹配大家都在看信息流
        "ad-text-bottom": Side_Ad,
        "ad-right-sponsor": Side_Ad,
        "fd-d": feedAdTemplateFunc.bind(feedAdInstance), // 匹配推荐阅读流
        "tw":feedAdTemplateFunc.bind(feedAdInstance), // 匹配24小时热文
        "default": feedAdTemplateFunc.bind(feedAdInstance)
    }
    return templateFuncMap[spmCCode] || templateFuncMap.default
}
export default getTemplate